import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 9042476D-79AC-4D50-AA53-EE71D3416BF3
 * name floor-lamp-torchiere
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/floor-lamp-torchiere.svg
 * tags
 * - Home Automation 
 */
export const FloorLampTorchiereIcon = createSvgIcon(<><path d="M7 2L10 9H14L17 2H7M13 20H16V22H8V20H11V10H13V20Z" /></>, 'FloorLampTorchiereIcon');
export default FloorLampTorchiereIcon